import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss'],
    standalone: false
})
export class RoleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
